import type { IconProps } from './types';
import './icons.css';

export default function File({
  width,
  height,
  className = '',
}: IconProps): React.JSX.Element {
  return (
    <svg
      width={width || 24}
      height={height || 24}
      viewBox="0 0 24 24"
      xmlns="http://www.w3.org/2000/svg"
      fill="none"
      className={`icon icon-file ${className || ''}`}
    >
      <path
        stroke="currentColor"
        strokeLinejoin="round"
        strokeMiterlimit="10"
        strokeWidth="2"
        d="M5 17V4c0-.551.449-1 1-1h8.586L19 7.414V20c0 .551-.449 1-1 1H6c-.551 0-1-.449-1-1v-3Z"
      />
      <path fill="currentColor" d="M18.5 8H15a1 1 0 0 1-1-1V3.5L18.5 8Z" />
    </svg>
  );
}
